import script from "./PrincipalPageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrincipalPageView.vue?vue&type=script&setup=true&lang=ts"

import "./PrincipalPageView.vue?vue&type=style&index=0&id=e06498ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e06498ce"]])

export default __exports__